module.exports = __webpack_public_path__ + "assets/img/usb.bdeaa9e061750d24ff1a7cff15dd4b05.svg";